var __webpack_exports__ = {};
/*!*************************************!*\
  !*** ./src/js/collection-layout.js ***!
  \*************************************/
var grid = {
  one: "grid--1-col-desktop",
  two: "grid--2-col-desktop"
};
var button = {
  one: "one-col",
  oneActive: "one-col active",
  two: "two-col",
  twoActive: "two-col active"
};
var filterButton = {
  show: ".show-filters",
  hide: ".hide-filters"
};
var asideFilter = document.getElementById('main-collection-filters');
var layoutChangeButtons = document.querySelectorAll('.layout-toggle button');
var productGrid = document.getElementById('product-grid');
var showButtonElement = document.querySelector(filterButton.show);
var hideButtonElement = document.querySelector(filterButton.hide);
var initLayout = function initLayout() {
  if (showButtonElement) {
    showButtonElement.addEventListener("click", toggleFilter);
  }
  if (hideButtonElement) {
    hideButtonElement.addEventListener("click", toggleFilter);
  }
  layoutChangeButtons.forEach(function (value) {
    value.onclick = function (e) {
      changeLayout(value);
      return false;
    };
  });
  if (asideFilter.classList.contains('hide')) {
    document.querySelector(filterButton.show).style.display = "block";
    document.querySelector(filterButton.hide).style.display = "none";
  } else {
    document.querySelector(filterButton.show).style.display = "none";
    document.querySelector(filterButton.hide).style.display = "block";
  }
};
function changeLayout(value) {
  productGrid = document.getElementById('product-grid');
  productGrid.classList.remove('grid--1-col-desktop');
  productGrid.classList.remove('grid--2-col-desktop');
  if (value.classList.value === button.one || value.classList.value === button.oneActive) {
    productGrid.classList.add('grid--1-col-desktop');
  } else if (value.classList.value === button.two || value.classList.value === button.twoActive) {
    productGrid.classList.add('grid--2-col-desktop');
  }
  var activeButtons = document.querySelectorAll('.layout-toggle button.active');
  activeButtons.forEach(function (button) {
    button.classList.remove('active');
  });
  value.classList.add('active');
}
function toggleFilter() {
  asideFilter.classList.toggle('hide');
  if (asideFilter.classList.contains('hide')) {
    document.querySelector(filterButton.show).style.display = "block";
    document.querySelector(filterButton.hide).style.display = "none";
  } else {
    document.querySelector(filterButton.show).style.display = "none";
    document.querySelector(filterButton.hide).style.display = "block";
  }
}
window.addEventListener('load', initLayout);
